import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useOne } from '@refinedev/core';
import { get } from 'lodash';
import { DatePickerFilterOption } from 'interfaces';
import moment from 'moment';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index' as const,
    intersect: false,
  },
  stacked: false,
  plugins: {
    legend: {
      position: "bottom" as const,
      labels: {
        pointStyle: "circle",
        usePointStyle: true,
        padding: 40,
        align: "center"
      }
    }
  },
  scales: {
    y: {
      type: 'linear' as const,
      display: true,
      text: "Doanh thu",
      position: 'left' as const,
      title: {
        display: true,
        text: 'Revenue'
      },
      grid: {
        drawOnChartArea: false,
      },
    },
    // y1: {
    //   type: 'linear' as const,
    //   display: false,
    //   // position: 'right' as const,
    //   grid: {
    //     drawOnChartArea: false,
    //   },
    // },
    y2: {
      type: 'linear' as const,
      display: true,
      position: 'right' as const,
      title: {
        display: true,
        text: 'Tickets'
      },
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

const month_labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const quarter_labels = ['Q1', 'Q2', 'Q3', 'Q4'];

const month_label = (date: string) => {
  const daysInMonth = moment(date, "MM-YYYY").daysInMonth();
  const month = moment(date, "MM-YYYY").month()+1;
  return Array.from({length: daysInMonth}, (x, i) => `${('0' + (i+1)).slice(-2)}/${('0' + month).slice(-2)}`);
} 

export const SaleAndTicketChart = ({currentFilterValues} : {currentFilterValues: any}) => {
  const { data: chartData } = useOne<any>({
    resource: "dashboard/chart",
    id: "",
    meta: {
      resource: "data",
      filters: [
        {
          field: "organization_id",
          operator: "eq",
          value: currentFilterValues.chart_organization_id,
        },
        {
          field: "type",
          operator: "eq",
          value: currentFilterValues.chart_date_type
        },
        {
          field: "value",
          operator: "eq",
          value: currentFilterValues.chart_date_value
        },
        {
          field: "currency",
          operator: "eq",
          value: localStorage.getItem("currency")
        },
        {
          field: "ticket_platform",
          operator: "eq",
          value: currentFilterValues.chart_ticket_platform,
        },
        {
          field: "gateway_owner",
          operator: "eq",
          value: currentFilterValues.chart_gateway_owner ?? "",
        },
        {
          field: "gateway_partner_code",
          operator: "eq",
          value: currentFilterValues.chart_gateway_partner_code ?? "",
        },
        {
          field: "gateway_name",
          operator: "eq",
          value: currentFilterValues.chart_gateway_name ?? "",
        },
      ],
    },
    queryOptions: {
      enabled: !!currentFilterValues,
    } as any,
  });

  const getLabels = (dateOption: DatePickerFilterOption) => {
    switch(dateOption) {
      case DatePickerFilterOption.YEAR: return month_labels;
      case DatePickerFilterOption.QUARTER: return quarter_labels;
      case DatePickerFilterOption.MONTH: return month_label(currentFilterValues.chart_date_value);
      default: return [];
    }
  }
  
  const labels = getLabels(currentFilterValues.chart_date_type);

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Gross revenue',
        data: labels.map((month, index) => get(chartData?.data, `${index+1}.subtotal`, 0)),
        borderColor: '#1B9DA0',
        backgroundColor: '#E2F5F5',
        yAxisID: 'y',
      },
      {
        label: 'Net revenue',
        data: labels.map((month, index) => get(chartData?.data, `${index+1}.grand_total`, 0)),
        borderColor: '#EEAE0E',
        backgroundColor: '#E2F5F5',
        yAxisID: 'y',
      },
      {
        label: 'Tickets',
        data: labels.map((month, index) => get(chartData?.data, `${index+1}.total_item`, 0)),
        borderColor: '#8044FF',
        backgroundColor: '#E8E3FF',
        yAxisID: 'y2',
      },
    ],
  };

  return (
    <div className="h-[500px]">
     {chartData?.data ? <Line options={options} data={data} />  : <></>}
    </div>
  );
}